import React, {useEffect, useState} from "react";
import {Autocomplete, Box, Button, FormControl, FormGroup, Grid, TextField, InputLabel, MenuItem, Select} from "@mui/material";
import {DateTimePicker, LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {useGetGuidMapDSQuery} from "../../../core/api/ds-charge-api";
import DeleteIcon from "@mui/icons-material/Delete";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutlined';
import chargeConstants from "../../ChargeManagement/constants";

export default function Guid2Block(props) {
    const [stringArgs, setStringArgs] = useState(0)
    const [mephistoTag, setMephistoTag] = useState(0)
    const [amount, setAmount] = useState(0)
    const [guid2, setGuid2] = useState(null)
    const [endTime, setEndTime] = useState(null)
    const [guid, setGuid] = useState(null)
    const [type, setType] = useState(props.selectedItem?.value || '')

    const {
        data: guidMap,
    } = useGetGuidMapDSQuery()

    // Calculate number of visible fields to determine grid width
    const getVisibleFieldsCount = () => {
        const item = props.selectedITemList[props.index].item;
        let count = 1; // Type field is always visible

        if (item.guidMap !== null && item.guidMap !== "") count++;
        if (item.guidMap2 !== null && item.guidMap2 !== "") count++;
        if (item.amount === true) count++;
        if (item.stringArgs === true) count++;
        if (item.endTime === true) count++;

        return count;
    }

    // Calculate width for each field
    const getFieldWidth = () => {
        const count = getVisibleFieldsCount();
        return 12 / Math.min(count, 6); // 12 is the total width in Material-UI grid
    }

    useEffect(() => {
        const current = props.selectedITemList[props.index];

        if (props.resetData) {
            if (guid !== null) setGuid(null);
            if (guid2 !== null) setGuid2(null);
            // не трогаем amount/stringArgs/mephistoTag/endTime — их контролирует родитель
        } else {
            // инициализация локального стейта из уже заполненного selectedITemList
            // (в том числе при загрузке Template)
            if (current.guid && current.guid !== guid) {
                setGuid(current.guid);
            }
            if (current.guid2 && current.guid2 !== guid2) {
                setGuid2(current.guid2);
            }
            if (current.endTime && current.endTime !== endTime) {
                setEndTime(current.endTime);
            }
            if (typeof current.amount !== "undefined" && current.amount !== amount) {
                if (current.item?.amountAttribute === "seconds") {
                    setAmount(current.amount / 3600);
                } else {
                    setAmount(current.amount);
                }
            }
            if (typeof current.stringArgs !== "undefined" && current.stringArgs !== stringArgs) {
                setStringArgs(current.stringArgs);
            }
            if (typeof current.mephistoTag !== "undefined" && current.mephistoTag !== mephistoTag) {
                setMephistoTag(current.mephistoTag);
            }
        }

        let newValidateChildrenList = [...props.validateChildrenList];
        newValidateChildrenList[props.index] = !checkChargeButtonDisable();
        props.setValidateChildrenList(newValidateChildrenList);

    }, [guid, guid2, props.selectedITemList[props.index]])

    const checkChargeButtonDisable = () => {
        return (((props.selectedITemList[props.index]["item"].guidMap !== "") && guid == null) ||
            ((props.selectedITemList[props.index]["item"].guidMap2 !== "") && guid2 == null) ||
            !props.selectedITemList[props.index]["item"].value)
    }

    const handleChangeAmount = (event) => {
        const newAmount = event.target.value;

        if (props.selectedITemList[props.index]["item"].value === 'OffsetBattleAutoLevel' && newAmount > 0) {
            return;
        }

        if (props.selectedITemList[props.index]["item"].amountAttribute === 'seconds') {
            updateItemInList("amount", newAmount * 3600);
        } else {
            updateItemInList("amount", newAmount);
        }
        setAmount(newAmount)
    }

    const handleChangeStringArgs = (event) => {
        setStringArgs(event.target.value)
        updateItemInList("stringArgs", event.target.value);
    }
    const handleChangeMephistoTag = (event) => {
        setMephistoTag(event.target.value)
        updateItemInList("mephistoTag", event.target.value);
    }

    const handleChangeType = (event) => {
        const selectedType = event.target.value;
        setType(selectedType);

        // Find the charge type from the list
        const selectedChargeType = props.chargeTypes.find(item => item.name === selectedType);

        // Update the item with the new type
        let newItem = {
            ...props.selectedITemList[props.index],
            "item": selectedChargeType
        };

        // Reset dependent fields
        setGuid(null);
        setGuid2(null);

        let newSelectedItemList = [...props.selectedITemList];
        newSelectedItemList[props.index] = newItem;
        props.setSelectedItemList(newSelectedItemList);
    }

    const handleChangeItem2 = (event, values) => {
        props.setResetData(false)
        setGuid2(values)
        updateItemInList("guid2", values);
    }

    // Helper function to update item in list
    const updateItemInList = (field, value) => {
        let newItem = {...props.selectedITemList[props.index], [field]: value};
        let newSelectedItemList = [...props.selectedITemList];
        newSelectedItemList[props.index] = newItem;
        props.setSelectedItemList(newSelectedItemList);
    }

    const handleChangeItem = (event, values) => {
        setAmount(0);
        props.setResetData(false)
        setGuid(values)

        let newItem = {
            ...props.selectedITemList[props.index],
            "guid": values,
            "amount": 0
        };

        let newSelectedItemList = [...props.selectedITemList];
        newSelectedItemList[props.index] = newItem;
        props.setSelectedItemList(newSelectedItemList);
    }

    const handleAddItem = () => {
        let newSelectedItemList = [...props.selectedITemList];
        // Add a new empty item
        newSelectedItemList.push({"item": {"value": "", "guidMap": "", "guidMap2": ""}});
        props.setSelectedItemList(newSelectedItemList)
    }

    const handleRemoveItem = () => {
        let newSelectedItemList = [...props.selectedITemList];
        newSelectedItemList.splice(props.index, 1);
        props.setSelectedItemList(newSelectedItemList)

        let newValidateChildrenList = [...props.validateChildrenList];
        newValidateChildrenList.splice(props.index, 1);
        props.setValidateChildrenList(newValidateChildrenList);
    }

    const handleSetTime = (value) => {
        setEndTime(value)
        updateItemInList("endTime", value);
    }

    const fieldWidth = getFieldWidth();

    const getMephistoTagSelector = (selectedItem) => {
        const selectInput = <TextField
            fullWidth
            variant="outlined"
            value={selectedItem.mephistoTag || ""}
            label="Mephisto Tag"
            onChange={handleChangeMephistoTag}
        />

        const mephistoTags = selectedItem.item.mephistoTag
        if(mephistoTags === "") return selectInput
        try {
            const tags = mephistoTags.split(',')
            return  <FormControl fullWidth><InputLabel>Mephisto Tag</InputLabel><Select
                value={selectedItem.mephistoTag || ""}
                label="Mephisto Tag"
                onChange={handleChangeMephistoTag}
            >
                {tags.map(item => (
                    <MenuItem value={item}>{item}</MenuItem>

                ))}
            </Select></FormControl>
        } catch(e) {
            return selectInput
        }


    }


    return (
        <Box sx={{ mb: 3 }}>
            <Grid container spacing={2} sx={{
                alignItems: "center"
            }}>
                {/* Type Selection */}
                <Grid size={{ xs: fieldWidth }}>
                    <FormControl fullWidth>
                        <InputLabel id={`type-select-label-${props.index}`}>Type</InputLabel>
                        <Select
                            value={props.selectedITemList[props.index].item.value}
                            label="Type"
                            onChange={handleChangeType}
                        >
                            {props.chargeTypes && props.chargeTypes.map((item) => (
                                <MenuItem key={item.name} value={item.name}>{item.name}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>

                {/* GUID Selection */}
                {(guidMap && props.selectedITemList[props.index].item.guidMap != null &&
                    props.selectedITemList[props.index].item.guidMap !== "" &&
                    guidMap.hasOwnProperty(props.selectedITemList[props.index].item.guidMap)) && (
                    <Grid size={{ xs: fieldWidth }}>
                        <Autocomplete
                            disablePortal
                            id={`guid-select-${props.index}`}
                            options={guidMap[props.selectedITemList[props.index].item.guidMap]}
                            getOptionLabel={(item) => item.displayName || ""}
                            value={props.selectedITemList[props.index].guid === undefined ? "" : props.selectedITemList[props.index].guid}
                            onChange={handleChangeItem}
                            renderOption={(props, option) => (
                                <li {...props} key={option.guid}>
                                    {option.displayName}
                                </li>
                            )}
                            renderInput={(params) => <TextField {...params} label={props.selectedITemList[props.index].item.guidMap}/>}
                        />
                    </Grid>
                )}

                {/* GUID2 Selection */}
                {props.selectedITemList[props.index].item &&
                    (props.selectedITemList[props.index].item.guidMap2 != null &&
                        props.selectedITemList[props.index].item.guidMap2 != "" &&
                        guidMap && guidMap.hasOwnProperty(props.selectedITemList[props.index].item.guidMap2)) && (
                        <Grid size={{ xs: fieldWidth }}>
                            <Autocomplete
                                disablePortal
                                id={`guid2-select-${props.index}`}
                                options={guidMap[props.selectedITemList[props.index].item.guidMap2]}
                                getOptionLabel={(item) => item.displayName}
                                value={guid2}
                                onChange={handleChangeItem2}
                                renderOption={(props, option) => (
                                    <li {...props} key={option.guid}>
                                        {option.displayName}
                                    </li>
                                )}
                                renderInput={(params) => <TextField {...params} label={props.selectedITemList[props.index].item.guidMap2}/>}
                            />
                        </Grid>
                    )}

                {/* Amount Field */}
                {props.selectedITemList[props.index].item.amount === true && (
                    <Grid size={{ xs: fieldWidth }}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            value={props.selectedITemList[props.index].amount ?
                                (props.selectedITemList[props.index]["item"].amountAttribute === 'seconds' ?
                                    props.selectedITemList[props.index].amount / 3600 :
                                    props.selectedITemList[props.index].amount) : 0}
                            label={props.selectedITemList[props.index]["item"].amountAttribute === 'seconds' ?
                                "Hours" :
                                (props.selectedITemList[props.index]["item"].amountAttribute || "Amount")}
                            onChange={handleChangeAmount}
                            type="number"
                            InputProps={{
                                inputProps: {
                                    min: props.selectedITemList[props.index]["item"].value === 'OffsetBattleAutoLevel' ? undefined : 0,
                                    max: props.selectedITemList[props.index]["item"].value === 'OffsetBattleAutoLevel' ? 0 : undefined,
                                    step: props.selectedITemList[props.index]["item"].amountAttribute === 'seconds' ? 0.1 : 1
                                }
                            }}
                        />
                    </Grid>
                )}

                {/* StringArgs Field */}
                {props.selectedITemList[props.index].item.stringArgs === true && (
                    <Grid size={{ xs: fieldWidth }}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            value={props.selectedITemList[props.index].stringArgs || ""}
                            label="StringArgs"
                            onChange={handleChangeStringArgs}
                        />
                    </Grid>
                )}

                {/* StringArgs Field */}
                {props.selectedITemList[props.index].item.mephistoTag != undefined && props.selectedITemList[props.index].item.mephistoTag.length>0 && (
                    <Grid size={{ xs: fieldWidth }}>
                        {getMephistoTagSelector(props.selectedITemList[props.index])}

                    </Grid>
                )}



                {/* EndTime Picker */}
                {props.selectedITemList[props.index].item.endTime === true && (
                    <Grid size={{ xs: fieldWidth }}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DateTimePicker
                                label="End Time"
                                value={endTime}
                                onChange={(newValue) => handleSetTime(newValue)}
                                format={'DD/MM/YYYY HH:mm'}
                                slotProps={{
                                    textField: {
                                        fullWidth: true,
                                        variant: "outlined"
                                    }
                                }}
                            />
                        </LocalizationProvider>
                    </Grid>
                )}
            </Grid>
            {/* Action Buttons (hidden in single mode — one charge item, used by the mass-charge item picker) */}
            {!props.single && <Grid container spacing={1} sx={{ mt: 1 }}>
                {(props.index !== 0 || (props.index === 0 && props.selectedITemList.length > 1)) && (
                    <Grid>
                        <Button
                            variant="outlined"
                            startIcon={<DeleteIcon/>}

                            color={"error"}
                            onClick={handleRemoveItem}
                        >
                            Remove
                        </Button>
                    </Grid>
                )}

                {props.index === props.selectedITemList.length - 1 && (
                    <Grid>
                        <Button
                            startIcon={<AddCircleOutlineIcon />}
                            variant="outlined"
                            color="info"
                            onClick={handleAddItem}
                        >
                            Add
                        </Button>
                    </Grid>
                )}
            </Grid>}
        </Box>
    );
}
